import { arrayUnion } from 'firebase/firestore';
import { auth } from '../firebase';

// Human-readable name of whoever is signed in right now.
// Falls back to email, then "Unknown" if no display name is set.
export function getActorName() {
  try {
    const u = auth?.currentUser;
    if (!u) return 'Unknown';
    return u.displayName || u.email || 'Unknown';
  } catch (e) {
    return 'Unknown';
  }
}

// Build one activity-log entry for an order line.
// A client-side ISO timestamp is used on purpose: Firestore's serverTimestamp()
// sentinel cannot be stored inside an array element, and an array is the cheapest
// place to keep a short per-line history (no extra document reads or writes).
export function buildLineActivityEntry(event, opts = {}) {
  const { from = null, to = null, by, details = null } = opts;
  const entry = {
    at: new Date().toISOString(),
    event: String(event || 'Updated'),
    by: by || getActorName()
  };
  if (from != null && from !== '') entry.from = from;
  if (to != null && to !== '') entry.to = to;
  if (details != null && details !== '') entry.details = details;
  return entry;
}

// Field fragment that appends one entry to a line's `activityLog`.
// Fold it into an existing updateDoc so it costs no additional write:
//   await updateDoc(lineRef, { ...updateData, ...activityLogAppend('Marked as CUT', { from, to }) });
export function activityLogAppend(event, opts = {}) {
  return { activityLog: arrayUnion(buildLineActivityEntry(event, opts)) };
}

// Initial activity-log value for a brand-new line (used with addDoc / setDoc).
export function activityLogInit(event = 'Created', opts = {}) {
  return [buildLineActivityEntry(event, opts)];
}
